import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=05486719"
import script from "./resource.vue?vue&type=script&lang=ts"
export * from "./resource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports